import { render, staticRenderFns } from "./PortfolioCreatorDialog.vue?vue&type=template&id=61cf541e&scoped=true&"
import script from "./PortfolioCreatorDialog.vue?vue&type=script&lang=js&"
export * from "./PortfolioCreatorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cf541e",
  null
  
)

export default component.exports